/**
 * Supported contract versions. Reject or isolate unsupported ones (specs).
 */
export const SUPPORTED_CONTRACT_VERSIONS: readonly string[] = ['1.0'];

export function isContractVersionSupported(version: string): boolean {
  return SUPPORTED_CONTRACT_VERSIONS.includes(version);
}
